/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ./images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('./images', true)
// const imagePath = (name) => images(name, true)
require('jquery')

require('jquery')

import '../stylesheets/main.scss'

import { generateIfNotExists } from '../uteis/deviceToken'
import { setLocaleFromRails } from '../uteis/locale'
import InputLabelPlaceholderEffect from './input_label_placeholder_effect'

import * as Sentry from "@sentry/browser";
import initializeSentry from './initialize_sentry'

import { autoRedirectFromWebview } from '../uteis/autoRedirect'
import 'controllers'
import { UtmParamsStorage } from '../../../ingressos-repo/app/shared/javascripts/utils/utm_params_storage';
import Mascaras from '../../../ingressos-repo/app/shared/javascripts/utils/mascaras'

window.autoRedirectFromWebview = autoRedirectFromWebview
window.UtmParamsStorage = new UtmParamsStorage;

document.addEventListener('DOMContentLoaded', () => {
  generateIfNotExists();
  setLocaleFromRails();
  initializeSentry();

  global.Mascaras = new Mascaras();
  global.Mascaras.start()

  new InputLabelPlaceholderEffect().start();
})

window.notificarSentry = (error) => {
  Sentry.captureException(error)
}
